export default __webpack_public_path__ + "static/media/fluxo.3cea3907.svg";